import React, { useEffect } from "react";
import { Flex } from "rebass";
import ProjectTitle from "./ProjectTitle";

const projects = [
  {
    title: "DESIGN SYSTEM(S)",
    desc: "First desc",
    discipline: "UI/FE",
    id: "10",
    page: "/design-system/",
    year: "2019 - 2020",
  },
  {
    title: "LAPIERRE",
    desc: "Second desc",
    discipline: "UI/DS/FE",
    id: "12",
    page: "/lapierre/",
    year: "2020 - 2021",
  },
  {
    title: "eCOMMERCE",
    desc: "Second desc",
    discipline: "DS/UI/FE",
    id: "14",
    page: "/ecom-platform/",
    year: "2018",
  },
];

const ProjectTitleListing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section>
      <Flex
        flexWrap="wrap"
        justifyContent="space-between"
        variant="container"
      >
        {/* Project title list */}
        {projects.map((project, index) => (
          <ProjectTitle
            page={project.page}
            title={project.title}
            discipline={project.discipline}
            year={project.year}
            id={project.id}
            key={project.id.toString()}
            index={index}
          />
        ))}
      </Flex>
    </section>
  );
};

export default ProjectTitleListing;
